export default "__VITE_ASSET__59170259__"